// extracted by mini-css-extract-plugin
module.exports = {"bcChapterWriting":"bcchapter_bcChapterWriting__jYc0R"};